import { RECEIVE_TERM_BY_ID, RECEIVE_TERMS } from '../actions/terms-preview.actions';

export default (state = {}, action) => {
  switch (action.type) {
    case RECEIVE_TERM_BY_ID:
      return {
        ...state,
        selectedTerm: { ...action.selectedTerm },
      };
    case RECEIVE_TERMS:
      return {
        list: [...action.list.reverse()],
        ...state,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/terms-preview/reducers/terms-preview.reducer.js